import mapSceneToComponent from '../mapSceneToComponent.js'
import script from './nefariousHero.json'
import { factoryStreet, maranui } from '../locations.js'

export const Scene = (scene) => () => {
  return (
    <>
      {scene.map(mapSceneToComponent)}
    </>
  )
}

const scenes = script.scenes

// Generated from Nefarious_Hero_message_and_map_v6.docx (script_stuff/POSTGRAD game files) by the
// script-to-stories skill. Location names in the v6 docx are canonical; each
// path maps 'Theater' to its own factory* constant so markers from parallel
// paths don't stack. 'DIRECT' / 'NONE' entries are null.
const conversations = [
  {
    from: 'Paige',
    messages: [
      { text: 'You should come have a drink after closing I want to tell you about these fuckers that scammed us.', isFromMe: false },
      { text: 'Message back, you loser', isFromMe: false },
      { text: 'Check your phone', isFromMe: false },
      { text: 'Check you phone ffs', isFromMe: false },
      { text: 'Seriously', isFromMe: false },
      { text: 'Hey! Sorry, just been busy. Shall I come tonight?', isFromMe: true },
      { text: 'That would be delightful', isFromMe: false }
    ]
  },
  {
    from: 'Paige',
    messages: [
      { text: 'Call me back', isFromMe: false },
      { text: 'You don\'t check your messenger?', isFromMe: false },
      { text: 'Ffs', isFromMe: false },
      { text: 'Are you ignoring me? idk', isFromMe: false },
      { text: 'OK fine then. I will call the work number. J will be thrilled to hear from me', isFromMe: false }
    ]
  },
  {
    from: 'Paige',
    messages: [
      { text: 'Come over I\'m working late', isFromMe: false }
    ]
  },
  {
    from: 'Paige',
    messages: [
      { text: 'It\'s working! Phone is on the move!!!', isFromMe: false },
      { text: 'Its at place in Kilbirnie', isFromMe: false },
      { text: 'It on the way to you!!!', isFromMe: false }
    ]
  },
  {
    from: 'Paige',
    messages: [
      { text: 'I bought the latest iphone!!!', isFromMe: false },
      { text: 'I kept the packaging', isFromMe: false },
      { text: 'I was real careful when I open the little seal things', isFromMe: false },
      { text: 'We can put my current phone in the new packaging and send that', isFromMe: false },
      { text: 'OK. Makes sense. Might as well use the lab when we put the phone into the new packaging. You should come over one morning before Junior gets here.', isFromMe: true }
    ]
  },
  {
    from: 'Paige',
    messages: [
      { text: 'Its on the move!!!', isFromMe: false },
      { text: 'Call me back or', isFromMe: false },
      { text: 'Actually i just talk u irl', isFromMe: false }
    ]
  },
  {
    from: 'Paige',
    messages: [
      { text: 'Come over have a wine and phone stalk this dickhead?', isFromMe: false },
      { text: 'Yep', isFromMe: true },
      { text: 'You answered!', isFromMe: false },
      { text: 'I\'ll call you soon', isFromMe: true }
    ]
  },
  {
    from: 'Paige',
    messages: [
      { text: 'You want to pick me up at 10:40am one morning this week?', isFromMe: true },
      { text: 'Hey! Why?', isFromMe: false },
      { text: 'I have a plan', isFromMe: true },
      { text: 'What is it?', isFromMe: false },
      { text: 'I\'ll show you when we do it.', isFromMe: true }
    ]
  },
  null // DIRECT
]

const markers = [
  { location: maranui, text: 'Drinks after closing.' }, // docx loc: 'Cafe'
  { location: factoryStreet, text: 'Should probably message Paige about the scam' }, // docx loc: 'Theater'
  { location: maranui, text: 'Better than an Air Tag' }, // docx loc: 'Cafe'
  { location: factoryStreet, text: 'Be at theater when courier arrives' }, // docx loc: 'Theater'
  { location: factoryStreet, text: 'Meet Paige before Junior arrives.' }, // docx loc: 'Theater'
  { location: factoryStreet, text: 'Jump in with Paige' }, // docx loc: 'Theater'
  { location: maranui, text: 'Meet Paige to phone stalk the dickhead' }, // docx loc: 'Cafe'
  { location: factoryStreet, text: 'Paige 10:40am pick up' }, // docx loc: 'Theater'
  null // DIRECT
]

const teasers = [
  'How to get revenge on the scammers?',
  'How to stalk this scam guy?',
  'Will the test phone work?',
  'Do it for real?',
  'Will they get caught after sending the tracking phone?',
  'Why is an investigator looking for the scam guy?',
  'How did he guess the phone was a trap?',
  null, // DIRECT
  'END of Chapter One.'
]


const art = [
  { url: '/nefarious_hero/scene1.png' },
  { url: '/nefarious_hero/scene2.png' },
  { url: '/nefarious_hero/scene3.png' },
  { url: '/nefarious_hero/scene4.png' },
  { url: '/nefarious_hero/scene5.png' },
  { url: '/nefarious_hero/scene6.png' },
  { url: '/nefarious_hero/scene7.png' },
  { url: '/nefarious_hero/scene8.png' },
  { url: '/nefarious_hero/scene9.png' }
]

// AUTO-GENERATED by scripts/deriveTimesOfDay.js — do not hand-edit; rerun `npm run derive-times-of-day` instead.
// Derived from each scene's opening SceneHeading in nefariousHero.json.
// (DAY -> afternoon, MORNING -> morning, EVENING -> evening, NIGHT -> evening;
// a CONTINUOUS/LATER opening heading inherits the previous scene's slot.)
const timesOfDay = [
  'evening', // 0: INT. CAFE - EVENING
  'evening', // 1: INT. LOBBY - AT TICKET COUNTER - NIGHT
  'evening', // 2: INT. PAIGE'S OFFICE - NIGHT
  'morning', // 3: INT. CORRIDOR OUTSIDE FRUITING ROOM - MORNING
  'morning', // 4: INT. LOBBY - INSIDE FRONT DOOR - MORNING
  'morning', // 5: INT. LOBBY - AT TICKET COUNTER - MORNING
  'evening', // 6: INT. CAFE KITCHEN - NIGHT
  'afternoon', // 7: INT. PAIGE'S CAR - AFTERNOON
  'afternoon', // 8: EXT. IN FRONT OF PORSCHE GUY'S HOUSE - CONTINUOUS (inherited)
]

const stories = scenes.map((scene, i) => ({
  timeOfDay: timesOfDay[i],
  sceneArt: art[i],
  scene,
  conversation: conversations[i] || undefined,
  marker: markers[i] || undefined,
  teaser: teasers[i] || undefined
}))

export default stories
